// import React, { useEffect } from 'react'
// import Wrapper from '../../UI/Wrapper'
// import Sidebar from '../../components/Common/Sidebar'
// import Main from '../../components/FormScreen/Main'
// import Left from '../../components/Client/FindTherapist/Left'
// import Right from '../../components/Client/FindTherapist/Right'
// import { useState } from 'react'
// import { useSelector } from 'react-redux'
// import ReactGA from "react-ga"
// import { useGetPriceQuery } from '../../services/currencyApi' 
// const FindTherapist = () => {
//     const [gender, setGender] = useState('')
//     const [lgbtq, setLgbtq] = useState('')
//     const [language, setLanguage] = useState('')
// const currency = useSelector((state) => state.therapistReducer.currency);
//   const reduxCurrencyString = useSelector((state) => state.therapistReducer.currency);
//   console.log(reduxCurrencyString);
  
//      const getCurrencyInfo = () => {
//         if (reduxCurrencyString) {
//             console.log("v");
            
//             const [idStr, code] = reduxCurrencyString.split(" ");
//             return { id: parseInt(idStr, 10), code: code || "AED" };
//         }
//         const stored = JSON.parse(localStorage.getItem("currency") || "{}");
//         return { id: stored?.id || 1, code: stored?.code || "AED" };
//     };

//     const [currencyInfo, setCurrencyInfo] = useState(getCurrencyInfo);
    
//     const storedCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
//     console.log(storedCurrency);
//    const [currencyId, setCurrencyId] = useState(() => {
//   const stored = JSON.parse(localStorage.getItem("currency") || "{}");
//   return stored?.id || 1; // default AED
// });
// const [currencySymbol, setCurrencySymbol] = useState(() => {
//   const stored = JSON.parse(localStorage.getItem("currency") || "{}");
//   return stored?.code || "AED";
// });
// // const currencyId = storedCurrency?.id;
//     const categoryName = useSelector(
//         (state) => state.therapistReducer.categoryName
//     )
//     console.log(categoryName);
    
//     const Amount =useSelector((state)=>state.therapistReducer.amount)
// console.log(Amount);
// const categoryId=localStorage.getItem("categoryid")
// // useEffect(() => {
// //   if (!currency) return;
// //   const [idStr] = currency.split(" ");
// //   const id = parseInt(idStr, 10);
// //   if (id !== currencyId) setCurrencySymbol(id);
// // }, [currency]);
//  useEffect(() => {
//         if (reduxCurrencyString) {
//             console.log(reduxCurrencyString);
//             refetch();
//             const [idStr, code] = reduxCurrencyString.split(" ");
//             const newId = parseInt(idStr, 10);
//             const newSymbol = code || "AED";

//             if (newId !== currencyInfo.id) {
//                 setCurrencyInfo({ id: newId, code: newSymbol });
//                 refetch();
//                 // NOTE: No need to call refetch() here, RTK Query does it for you 
//                 // because the query argument (currencyInfo.id) changed.
//             }
//         }
//     }, [reduxCurrencyString, currencyInfo.id]);
//     console.log(currencyInfo.id);
    
// const { data,refetch, isLoading } = useGetPriceQuery({ categoryId,currencyId: currencyInfo.id},{ skip: !categoryId || !currencyInfo.id });
// console.log("pricedata",data);
// // If currency changes elsewhere (e.g., Sidebar dropdown), listen to localStorage
//   useEffect(() => {
//     const handleStorageChange = () => {
//       const stored = JSON.parse(localStorage.getItem("currency") || "{}")
//       if (stored?.id && stored.id !== currencyId) {
//         setCurrencyId(stored.id) // triggers refetch automatically
//      setCurrencySymbol(stored.code); 
//      refetch();
//     }
//     }
//     window.addEventListener("storage", handleStorageChange)
//     return () => window.removeEventListener("storage", handleStorageChange)
//   }, [currencyId])
//     //Google Analytics
//     useEffect( () => {
//         ReactGA.pageview(window.location.pathname)
//     }, [])

//     return (
//         <Wrapper>
//             <div className="flex">
//                 <Sidebar findTherapist={true} notLoggedIn={false} />
//                 <Main>
//                     <div className='flex flex-col'>
                      
//                        <div className='flex items-center  xl:gap-[22rem] '> 
//                         <span className="font-constantia  mt-4 ml-12 font-bold text-3xl">
//                             { categoryName?.toLowerCase() == ("MENTAL HEALTH").toLowerCase() ? "Find your Therapist" : "Find your Coach"}
//                             {/* Find Your Coach - {categoryName} */}
//                         </span>
//                         <span className='font-constantia text-2xl font-bold mt-4 ml-3  rounded-full p-3 text-orange'>{Amount && (() => {
//   const [currency, price] = Amount.split(' ');
//   return (
//     <span className="font-constantia text-2xl mt-10 ml-3">
      
//       <span className="font-bold font-constantia ">Session Fee: {storedCurrency.code}</span>{' '}
//       <span className="font-mono">{data?.price?.amount}</span>
      
//     </span>
//   );
// })()}</span>

//                         </div>
//                         {/* <p className="ml-12 mt-2 text-lg font-semibold text-gray-600">
//   {Amount ? `Session Fee: ${Amount}` : ""}
// </p> */}
//                         <div className="flex gap-0 align-middle findTherapistWrapper">
//                             <Left
//                                 gender={gender}
//                                 lgbtq={lgbtq}
//                                 language={language}
//                             />
//                             <Right
//                                 setGender={setGender}
//                                 gender={gender}
//                                 lgbtq={lgbtq}
//                                 setLgbtq={setLgbtq}
//                                 language={language}
//                                 setLanguage={setLanguage}
//                             />
//                         </div>
//                     </div>
//                 </Main>
//             </div>
//         </Wrapper>
//     )
// }

// export default FindTherapist




import React, { useEffect, useState } from 'react';
import Wrapper from '../../UI/Wrapper';
import Sidebar from '../../components/Common/Sidebar';
import Main from '../../components/FormScreen/Main';
import Left from '../../components/Client/FindTherapist/Left';
import Right from '../../components/Client/FindTherapist/Right';
import { useSelector } from 'react-redux';
import ReactGA from "react-ga";
import { useGetPriceQuery } from '../../services/currencyApi'; 
import api from '../../services/api';
const FindTherapist = () => {
    const [gender, setGender] = useState('');
    const [lgbtq, setLgbtq] = useState('');
    const [language, setLanguage] = useState('');
    // --- OTHER REDUX STATE ---
    const categoryName = useSelector((state) => state.therapistReducer.categoryName);
    // const Amount = useSelector((state)=>state.therapistReducer.amount); // *** REMOVED: No longer needed ***
    const categoryId = localStorage.getItem("categoryid");
    
    
    const stored = JSON.parse(localStorage.getItem("currency") || "{}");
    // --- CURRENCY STATE MANAGEMENT ---
    const reduxCurrencyString = useSelector((state) => state.therapistReducer.currency);
    console.log(reduxCurrencyString,"ghhhh");
    
    const [idStr, code] = reduxCurrencyString.split(" ");
            const currid=parseInt(idStr, 10);
            const currcode=code
    // Function to derive the currency ID and Code from Redux or localStorage default
    const getCurrencyInfo = (() => {
        if (reduxCurrencyString) {
            // Split the string format "ID CODE"
            const [idStr, code] = reduxCurrencyString.split(" ");
            return { 
                id: parseInt(idStr, 10), 
                code: code || "AED" 
            };
        }
        // Fallback to localStorage on initial mount
        
        return { 
            id: stored?.id || 1, 
            code: stored?.code || "AED" 
        };
    })();
     const [currencyInfo, setCurrencyInfo] = useState(getCurrencyInfo);
    
   
    // Use a single state object for currency info (ID for API, Code for display)
   
    // Update local currencyInfo state whenever the Redux currency string changes
    useEffect(() => {
        if (reduxCurrencyString) {
            
            //  refetch();
             const [idStr, code] = reduxCurrencyString.split(" ");
            const newId = parseInt(idStr, 10);
            const newCode = code || "AED";
            
            
            api.get(`client/get-price/?category_id=${categoryId}&currency_id=${newId}`, {
			headers: {
				authorization: `Bearer ${localStorage.getItem("livtoken")}`,
			}
		}).then((res) => {
			
            setCurrencyInfo({ id: newId, code: newCode,amount:res?.data?.price?.amount });
		})
                  
           

            // Only update state if there's a real change
            if (newId !== currencyInfo.id || newCode !== currencyInfo.code) {
              
                api.get(`client/get-price/?category_id=${categoryId}&currency_id=${newId}`, {
			headers: {
				authorization: `Bearer ${localStorage.getItem("livtoken")}`,
			}
		}).then((res) => {
			
            setCurrencyInfo({ id: newId, code: newCode,amount:res?.data?.price?.amount });
		})
                 
                // setCurrencyInfo({ id: newId, code: newCode });
                
                
                // RTK Query will automatically refetch because currencyInfo.id changed!
            }
        }
    }, [reduxCurrencyString, currencyInfo.id, currencyInfo.code,categoryId]);

    

useEffect(()=>{
    const [idStr, code] = reduxCurrencyString.split(" ");
            const newId = parseInt(idStr, 10);
            const newCode = code || "AED";
api.get(`client/get-price/?category_id=${categoryId}&currency_id=${currid}`, {
			headers: {
				authorization: `Bearer ${localStorage.getItem("livtoken")}`,
			}
		}).then((res) => {
			
            setCurrencyInfo({ id: newId, code: newCode,amount:res?.data?.price?.amount });
		})
},[])


   
    //Google Analytics (Unchanged)
    useEffect( () => {
        ReactGA.pageview(window.location.pathname);
    }, []);


    return (
        <Wrapper>
            <div className="flex">
                <Sidebar findTherapist={true} notLoggedIn={false} />
                <Main>
                    <div className='flex flex-col therapistcontainer'>
                      
                       <div className='flex items-center xl:gap-[22rem]'> 
                        <span className="font-constantia mt-4 ml-12 font-bold text-3xl">
                            { categoryName?.toLowerCase() === ("MENTAL HEALTH").toLowerCase() ? "Find your Therapist" : "Find your Coach"}
                        </span>
                        
                        {/* --- FIXED DISPLAY LOGIC --- */}
                        <span className='font-constantia text-2xl font-bold mt-4 ml-3 rounded-full p-3 text-orange'>
                            {currencyInfo.amount ? (
                                // Display the new price using the current, correct code
                                <span className="font-constantia text-2xl mt-10 ml-3">
                                    <span className="font-bold font-constantia ">Session Fee:{currencyInfo.code}</span>{' '}
                                    <span className="font-mono">{currencyInfo.amount}</span>
                                </span>
                            ) : (
                                // Handle case where no price is available
                                <span className="font-constantia text-2xl mt-10 ml-3">Price Not Available</span>
                            )}
                        </span>
                        {/* --- END FIXED DISPLAY LOGIC --- */}
                        
                        </div>

                        <div className="flex gap-0 align-middle findTherapistWrapper">
                            <Left
                                gender={gender}
                                lgbtq={lgbtq}
                                language={language}
                            />
                            <Right
                                setGender={setGender}
                                gender={gender}
                                lgbtq={lgbtq}
                                setLgbtq={setLgbtq}
                                language={language}
                                setLanguage={setLanguage}
                            />
                        </div>
                    </div>
                </Main>
            </div>
        </Wrapper>
    )
}

export default FindTherapist;